import React from 'react';
import styled from '@emotion/native';
import { List } from 'react-native-paper';
import { BodyText } from '@/shared/components/StyledText';
import { white, green, lightGreen, mint } from '@/shared/styles/colors';
import { FAQItem as FAQItemType } from '@/shared/constants/faqData';

interface FAQItemProps {
  item: FAQItemType;
  itemId: string;
  isExpanded: boolean;
  onToggle: (itemId: string) => void;
}

const FAQItem = ({ item, itemId, isExpanded, onToggle }: FAQItemProps) => {
  return (
    <FAQItemContainer>
      <List.Accordion
        title={item.question}
        expanded={isExpanded}
        onPress={() => onToggle(itemId)}
        titleStyle={accordionTitleStyle}
        titleNumberOfLines={0}
        style={accordionStyle}
        theme={{
          colors: {
            primary: green,
          },
        }}
      >
        <AnswerContainer>
          <AnswerText>{item.answer}</AnswerText>
        </AnswerContainer>
      </List.Accordion>
    </FAQItemContainer>
  );
};

export default FAQItem;

const FAQItemContainer = styled.View({
  marginBottom: 8,
  backgroundColor: white,
  borderRadius: 8,
  elevation: 1,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 2,
});

const AnswerContainer = styled.View({
  paddingHorizontal: 16,
  paddingVertical: 12,
});

const AnswerText = styled(BodyText)({
  fontSize: 15,
  lineHeight: 22,
  fontWeight: '400' as const,
  color: lightGreen,
});

const accordionTitleStyle = {
  fontSize: 16,
  fontWeight: '400' as const,
  color: green,
  paddingRight: 8,
  lineHeight: 22,
};

const accordionStyle = {
  backgroundColor: mint,
  paddingVertical: 4,
};
